/* ============================================================
   DAVIE LAKE VIEW — Formulario por pasos

   Una pregunta por pantalla. Nada se despliega debajo de otra cosa: eso
   obliga a scrollear y rompe la sensación de conversación.

   Todo lo que tenga que ver con precios (modelos, pisos por categoría y
   rangos de presupuesto) sale del catálogo que publica `davie-modelos`.
   Acá no hay ni un precio escrito a mano.
   ============================================================ */
(function () {
  'use strict';

  var form = document.getElementById('davie-contact-form');
  if (!form) return;

  /* ============================================================
     Modo de prueba — corta las cuatro salidas del lead
     ============================================================ */
  var TEST_MODE = (function () {
    var el = document.getElementById('davie-test');
    return !!el && el.value === 'true';
  })();

  /* ============================================================
     Helpers
     ============================================================ */
  function $(id) { return document.getElementById(id); }
  function val(id) { var el = $(id); return el ? (el.value || '').trim() : ''; }
  function digits(s) { return (s || '').replace(/\D/g, ''); }
  function getCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
  function marcado(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : null; }
  function show(el, yes) { if (el) el.hidden = !yes; }
  function setHidden(id, v) { var el = $(id); if (el) el.value = v || ''; }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'davie-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  /* ============================================================
     Catálogo de modelos — fuente única de precios
     ============================================================ */
  function readCatalog() {
    try {
      var el = document.getElementById('davie-catalogo');
      if (!el) return [];
      var arr = JSON.parse(el.textContent || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  var CATALOGO = readCatalog();

  // Solo los disponibles cuentan para pisos y rangos: no tiene sentido publicar
  // un "desde" de un modelo que ya no se puede comprar.
  function vendibles(cat) {
    return CATALOGO.filter(function (m) {
      return m.available && m.price > 0 && (!cat || m.cat === cat);
    });
  }
  function piso(cat) {
    var ms = vendibles(cat);
    if (!ms.length) return null;
    return ms.reduce(function (min, m) { return m.price < min ? m.price : min; }, ms[0].price);
  }
  function hayCategoria(cat) { return vendibles(cat).length > 0; }

  var CAT_LABEL = { townhome: 'Townhomes', single: 'Single Family Homes' };
  var CAT_SINGULAR = { townhome: 'Townhome', single: 'Single Family Home' };

  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function moneyShort(n) {
    if (n >= 1000000) {
      var m = n / 1000000;
      return '$' + (m % 1 === 0 ? m.toFixed(0) : m.toFixed(2).replace(/0$/, '')) + 'M';
    }
    return '$' + Math.round(n / 1000) + 'K';
  }

  // Inicial del 5% — el mismo cálculo que ya muestran las tarjetas de modelos.
  // Sin esto la persona lee "$937,990" y asume que necesita el total en mano:
  // es la fricción más cara del formulario y se resuelve con una línea.
  var INICIAL_PCT = 0.05;
  function inicial(n) { return money(n * INICIAL_PCT); }

  // Los townhomes quedan por debajo del limite del conforming loan, asi que el
  // 5% es una cifra real y se muestra. Las casas lo pasan, y el inicial para
  // quedarse dentro sube mucho segun el modelo: dar UNA cifra ahi seria falso,
  // porque depende del programa. Andrew, 2026-09-15.
  // Esta funcion es el unico lugar donde se decide: si cambia la regla, cambia aca.
  var SIN_CIFRA = 'Down payment seg\u00fan el programa';
  function inicialTexto(cat, monto) {
    if (cat === 'townhome') return 'Inicial 5% <strong>' + inicial(monto) + '</strong>';
    return SIN_CIFRA;
  }

  /* ============================================================
     Rangos de presupuesto — se generan del piso real de cada categoría.
     La REGLA es fija (esto es lo que hay que validar, no los números):
     se arranca en el piso redondeado hacia abajo al múltiplo de $50K y se
     arman tramos de $100K, el último abierto hacia arriba.
     ============================================================ */
  // Los tramos salen del piso Y DEL TECHO reales de la categoría.
  // La versión anterior generaba tres tramos fijos de $100K hacia arriba desde
  // el piso y nunca miraba el techo, así que ofrecía rangos vacíos: para
  // Townhomes aparecía "$800K - $900K" cuando el más caro cuesta $767,690.
  var PASOS = [10000, 25000, 50000, 100000];
  var MAX_TRAMOS = 4;

  function abajo(n, p) { return Math.floor(n / p) * p; }
  function arriba(n, p) { return Math.ceil(n / p) * p; }

  function tramosDeCategoria(cat) {
    var ms = vendibles(cat);
    if (!ms.length) return [];
    var precios = ms.map(function (m) { return m.price; });
    var pisoCat = Math.min.apply(null, precios);
    var techoCat = Math.max.apply(null, precios);

    var desde = abajo(pisoCat, 10000);
    var hasta = arriba(techoCat + 1, 10000); // +1 para que el más caro entre
    var span = hasta - desde;

    // El paso más chico que no genere más de cuatro opciones.
    var paso = PASOS[PASOS.length - 1];
    for (var i = 0; i < PASOS.length; i++) {
      if (Math.ceil(span / PASOS[i]) <= MAX_TRAMOS) { paso = PASOS[i]; break; }
    }

    var out = [];
    for (var from = desde; from < hasta; from += paso) {
      out.push({ from: from, to: Math.min(from + paso, hasta) });
    }
    return out;
  }

  // "Ambas opciones": las dos escaleras, una detrás de la otra. Entre el
  // townhome más caro y el single family más barato hay un hueco real y no se
  // rellena: inventar un tramo ahí sería ofrecer algo que no existe.
  function tramosCombinados() {
    return tramosDeCategoria('townhome')
      .concat(tramosDeCategoria('single'))
      .sort(function (a, b) { return a.from - b.from; });
  }

  // Por debajo del piso de Davie: acá sí se muestran cifras menores, porque la
  // búsqueda pasa a ser fuera de Davie.
  function tramosPorDebajo(pisoGlobal) {
    var out = [], prev = 0;
    [300000, 450000, 600000].forEach(function (c) {
      if (c < pisoGlobal) { out.push({ from: prev, to: c }); prev = c; }
    });
    out.push({ from: prev, to: pisoGlobal });
    return out;
  }

  // El inicial de un tramo también es un tramo: se muestran las dos puntas
  // para no dar una cifra única que después no coincida con el modelo elegido.
  function inicialTramo(t) {
    // A esta altura ya eligio tipo de propiedad, asi que se sabe si toca cifra.
    if (S.tipo === 'single') return SIN_CIFRA;
    if (S.tipo !== 'townhome') return ''; // eligio "ambas": la cifra dependeria del modelo
    if (t.from === 0 && t.to === null) return ''; // tramo abierto de los dos lados
    if (t.from === 0) return 'Inicial 5% hasta <strong>' + inicial(t.to) + '</strong>';
    if (t.to === null) return 'Inicial 5% desde <strong>' + inicial(t.from) + '</strong>';
    return 'Inicial 5% <strong>' + inicial(t.from) + ' – ' + inicial(t.to) + '</strong>';
  }

  function etiquetaTramo(t) {
    if (t.from === 0) return 'Menos de ' + moneyShort(t.to);
    if (t.to === null) return 'Más de ' + moneyShort(t.from);
    return moneyShort(t.from) + ' – ' + moneyShort(t.to);
  }

  /* ============================================================
     Estado
     ============================================================ */
  var S = {
    situacion: null, acuerdo: null, licencia: null,
    tipo: null, tramo: null, modelo: null, modeloPrecio: null,
    plazo: null, pago: null, incentivos: null
  };
  var pendienteModelo = null; // llegó desde una tarjeta del explorador
  var enviado = false;

  /* ============================================================
     Secuencia de pantallas — dinámica
     ============================================================ */
  var MAX = 11; // la 11 es el aviso al Realtor, va después de la 3
  var actual = 1;

  function pasoEl(n) { return form.querySelector('.davie-step[data-step="' + n + '"]'); }

  // Modelos del tipo elegido que caen dentro del presupuesto declarado.
  // Preguntar por el modelo ANTES del presupuesto generaba un conflicto: la
  // persona elegía una casa de $732K y en la pantalla siguiente se le
  // preguntaba cuánto tenía, como si no la hubiéramos escuchado.
  function modelosEnRango() {
    if (!S.tipo || S.tipo === 'bajo' || !S.tramo) return [];
    var cats = S.tipo === 'ambas' ? ['single', 'townhome'] : [S.tipo];
    return CATALOGO.filter(function (m) {
      if (cats.indexOf(m.cat) < 0 || !(m.price > 0)) return false;
      if (m.price < S.tramo.from) return false;
      if (S.tramo.to !== null && m.price >= S.tramo.to) return false;
      return true;
    });
  }

  function pasosActivos() {
    var l = [1];
    if (S.situacion === 'con-realtor') l.push(2);
    // El Realtor no se descarta: contesta dónde tiene licencia, deja sus
    // datos, y entra a la planilla como NO CALIFICADO / REALTOR. Eso es lo que
    // sirve — con esa lista se arma la exclusión de la pauta de Meta.
    if (S.situacion === 'realtor') { l.push(3, 11, 10); return l; }
    l.push(4, 5);
    if (modelosEnRango().length) l.push(6);
    l.push(7, 8);
    if (S.pago !== 'Contado') l.push(9);
    l.push(10);
    return l;
  }
  function siguiente(n) { var l = pasosActivos(), i = l.indexOf(n); return i >= 0 && i < l.length - 1 ? l[i + 1] : n; }
  function anterior(n) { var l = pasosActivos(), i = l.indexOf(n); return i > 0 ? l[i - 1] : n; }
  function esUltimo(n) { var l = pasosActivos(); return l[l.length - 1] === n; }

  function ir(n) {
    actual = n;
    for (var i = 1; i <= MAX; i++) show(pasoEl(i), i === n);
    if (n === 11) pintarAvisoRealtor();
    if (n === 4) pintarPisos();
    if (n === 5) pintarPresupuesto();
    if (n === 6) pintarModelos();

    var lista = pasosActivos();
    var pos = lista.indexOf(n) + 1;
    var fill = $('davie-prog-fill');
    if (fill) fill.style.width = Math.round((pos / lista.length) * 100) + '%';

    show($('davie-back'), n > lista[0]);
    // Solo la pantalla 10 envia. Las ramas del filtro terminan en una salida,
    // asi que ahi el boton de enviar no debe asomar aunque sean la ultima.
    show($('davie-submit-btn'), n === 10);
    // "Continuar" solo donde el documento de Andrew pide una confirmación
    // explícita. El resto de las pantallas avanza sola al elegir.
    var next = $('davie-next');
    if (next) {
      if (n === 11) { next.textContent = 'Continuar'; show(next, true); }
      else if (n === 2 && S.acuerdo === 'no') { next.textContent = 'Quiero recibir orientación'; show(next, true); }
      else if (n === 4 && S.tipo === 'bajo') { next.textContent = 'Quiero explorar opciones en otras zonas'; show(next, true); }
      else show(next, false);
    }
    limpiarError();

    var card = form.closest('.davie-form-card') || form;
    var arriba = card.getBoundingClientRect().top + window.pageYOffset - 24;
    if (window.pageYOffset > arriba) window.scrollTo({ top: arriba, behavior: 'smooth' });
  }

  /* ---- Auto-avance ----------------------------------------------------------
     Apenas la pantalla queda contestada, se pasa sola. La pausa corta existe
     para que se alcance a ver marcada la opción elegida.
     -------------------------------------------------------------------- */
  var avanzando = false;
  function avanzar() {
    if (avanzando || esUltimo(actual)) return;
    avanzando = true;
    var desde = actual;
    setTimeout(function () {
      avanzando = false;
      if (actual === desde) ir(siguiente(desde));
    }, 260);
  }

  /* ---- Re-elegir la opción que ya estaba marcada -----------------------------
     Si alguien vuelve atrás y toca de nuevo la misma opción, el navegador no
     dispara `change` — el radio ya estaba marcado — y el formulario se quedaba
     quieto. Guardamos en `pointerdown` cuál estaba elegida ANTES del toque y,
     si el toque cae sobre esa misma, disparamos el `change` a mano. Cuando el
     toque sí cambia la opción no hacemos nada: se encarga el evento nativo, así
     que nunca corre dos veces.
     -------------------------------------------------------------------- */
  (function initReeleccion() {
    var antes = {};
    form.addEventListener('pointerdown', function (e) {
      var lbl = e.target && e.target.closest ? e.target.closest('label') : null;
      if (!lbl) return;
      var inp = lbl.querySelector('input[type="radio"]');
      if (!inp || !inp.name) return;
      var sel = form.querySelector('input[name="' + inp.name + '"]:checked');
      antes[inp.name] = sel ? sel.value : null;
    });
    form.addEventListener('click', function (e) {
      var inp = e.target;
      if (!inp || inp.tagName !== 'INPUT' || inp.type !== 'radio' || !inp.name) return;
      if (antes[inp.name] === inp.value) inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  /* ---- Errores ---- */
  function error(msg) { var e = $('davie-error'); if (e) { e.textContent = msg; e.hidden = false; } }
  function limpiarError() { var e = $('davie-error'); if (e) e.hidden = true; }

  /* ---- Salidas que terminan el flujo ---- */
  function salir(cual) {
    ocultarFormulario();
    form.querySelectorAll('.davie-exit').forEach(function (x) {
      x.hidden = x.getAttribute('data-exit') !== cual;
    });
    limpiarError();
  }

  /* ============================================================
     Selector de país (código telefónico) — default Estados Unidos
     ============================================================ */
  var COUNTRIES = [
    { n: 'Estados Unidos', d: '1', f: '🇺🇸' }, { n: 'Colombia', d: '57', f: '🇨🇴' },
    { n: 'México', d: '52', f: '🇲🇽' }, { n: 'Venezuela', d: '58', f: '🇻🇪' },
    { n: 'Argentina', d: '54', f: '🇦🇷' }, { n: 'Perú', d: '51', f: '🇵🇪' },
    { n: 'Ecuador', d: '593', f: '🇪🇨' }, { n: 'Chile', d: '56', f: '🇨🇱' },
    { n: 'Rep. Dominicana', d: '1', f: '🇩🇴' }, { n: 'Puerto Rico', d: '1', f: '🇵🇷' },
    { n: 'Panamá', d: '507', f: '🇵🇦' }, { n: 'Costa Rica', d: '506', f: '🇨🇷' },
    { n: 'Guatemala', d: '502', f: '🇬🇹' }, { n: 'Honduras', d: '504', f: '🇭🇳' },
    { n: 'El Salvador', d: '503', f: '🇸🇻' }, { n: 'Nicaragua', d: '505', f: '🇳🇮' },
    { n: 'Bolivia', d: '591', f: '🇧🇴' }, { n: 'Paraguay', d: '595', f: '🇵🇾' },
    { n: 'Uruguay', d: '598', f: '🇺🇾' }, { n: 'Brasil', d: '55', f: '🇧🇷' },
    { n: 'España', d: '34', f: '🇪🇸' }, { n: 'Canadá', d: '1', f: '🇨🇦' }
  ];
  var currentDial = '1';
  (function initPais() {
    var btn = $('davie-cc-btn'), list = $('davie-cc-list');
    var flag = $('davie-cc-flag'), dial = $('davie-cc-dial');
    if (!btn || !list) return;
    function cerrar() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    COUNTRIES.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'davie-phone__opt';
      li.setAttribute('role', 'option');
      li.innerHTML = '<span>' + c.f + '</span><span class="davie-phone__optn">' + c.n +
        '</span><span class="davie-phone__optd">+' + c.d + '</span>';
      li.addEventListener('click', function () {
        currentDial = c.d; flag.textContent = c.f; dial.textContent = '+' + c.d;
        cerrar();
        var ph = $('davie-phone'); if (ph) ph.focus();
      });
      list.appendChild(li);
    });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (list.hidden) { list.hidden = false; btn.setAttribute('aria-expanded', 'true'); } else cerrar();
    });
    document.addEventListener('click', function (e) {
      if (!list.hidden && !list.contains(e.target) && e.target !== btn) cerrar();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  })();

  function fullPhone() { return '+' + currentDial + ' ' + val('davie-phone'); }
  function phoneE164() { return '+' + currentDial + digits(val('davie-phone')); }

  /* ============================================================
     Pantallas 1, 2 y 3 · el filtro inicial
     ============================================================ */
  form.querySelectorAll('input[name="davie-situacion"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var cambio = r.value !== S.situacion;
      S.situacion = r.value;
      // Al Realtor no se le pregunta por que canal contactarlo: preguntarlo es
      // ofrecerle WhatsApp, y esa es la conversacion que no se quiere abrir.
      var canalBloque = $('davie-canal-bloque');
      if (canalBloque) canalBloque.hidden = (r.value === 'realtor');
      if (cambio) {
        S.acuerdo = null; S.licencia = null;
        form.querySelectorAll('input[name="davie-acuerdo"],input[name="davie-licencia"]')
          .forEach(function (x) { x.checked = false; });
        show(form.querySelector('[data-note="orientacion"]'), false);
      }
      setHidden('davie-situacion-out', situacionTexto());
      limpiarError();
      avanzar();
    });
  });

  form.querySelectorAll('input[name="davie-acuerdo"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.acuerdo = r.value;
      setHidden('davie-situacion-out', situacionTexto());
      if (r.value === 'si') { salir('con-agente'); return; }
      // El documento de Andrew pide una confirmación explícita en esta rama.
      show(form.querySelector('[data-note="orientacion"]'), true);
      var next = $('davie-next');
      if (next) { next.textContent = 'Quiero recibir orientación'; show(next, true); }
      limpiarError();
    });
  });

  form.querySelectorAll('input[name="davie-licencia"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.licencia = r.value;
      setHidden('davie-situacion-out', situacionTexto());
      limpiarError();
      avanzar();
    });
  });

  // Pantalla 11 — el mensaje cambia según dónde tenga la licencia.
  // Es solo texto: al Realtor no se le deja un campo para escribirle. Andrew
  // quiere sus datos para la lista de exclusión de Meta, no una conversación.
  // Por eso tampoco se le abre WhatsApp ni se le pregunta el canal.
  function pintarAvisoRealtor() {
    var paso = pasoEl(11);
    if (!paso) return;
    var fuera = S.licencia === 'fuera';
    var t = paso.getAttribute(fuera ? 'data-titulo-fuera' : 'data-titulo-fl') || '';
    var m = paso.getAttribute(fuera ? 'data-msg-fuera' : 'data-msg-fl') || '';
    var tEl = $('davie-realtor-titulo'), mEl = $('davie-realtor-msg');
    if (tEl) tEl.textContent = t;
    if (mEl) mEl.textContent = m;
  }

  /* ============================================================
     Pantalla 4 · tipo de propiedad
     ============================================================ */
  function pintarPisos() {
    var caja = $('davie-pisos'), lista = $('davie-pisos-list');
    if (!caja || !lista) return;
    var filas = [];
    ['townhome', 'single'].forEach(function (c) {
      var p = piso(c);
      if (p !== null) {
        filas.push('<li><span class="davie-pisos__cat">' + CAT_LABEL[c] + '</span>' +
          '<span class="davie-pisos__nums"><b>desde ' + money(p) + '</b>' +
          '<em>' + inicialTexto(c, p) + '</em></span></li>');
      }
    });
    if (!filas.length) { caja.hidden = true; return; } // sin catálogo no inventamos cifras
    lista.innerHTML = filas.join('');
    caja.hidden = false;
  }

  function pintarTipos() {
    var cont = $('davie-tipo-opts');
    if (!cont) return;
    var ops = [];
    ['townhome', 'single'].forEach(function (c) {
      if (!hayCategoria(c)) return; // categoría entera agotada: no se ofrece
      var p = piso(c);
      ops.push({
        v: c,
        t: CAT_SINGULAR[c],
        d: p !== null ? 'desde ' + money(p) + ' · ' + inicialTexto(c, p) : ''
      });
    });
    if (hayCategoria('townhome') && hayCategoria('single')) {
      ops.push({ v: 'ambas', t: 'Quiero explorar ambas opciones', d: '' });
    }
    ops.push({ v: 'bajo', t: 'Mi presupuesto es más bajo', d: 'Te ayudo a buscar fuera de Davie' });

    cont.innerHTML = ops.map(function (o) {
      return '<label class="davie-opt"><input type="radio" name="davie-tipo" value="' + o.v + '">' +
        '<span class="davie-opt__body"><b>' + o.t + '</b>' +
        (o.d ? '<em>' + o.d + '</em>' : '') + '</span></label>';
    }).join('');

    cont.querySelectorAll('input[name="davie-tipo"]').forEach(function (r) {
      r.addEventListener('change', onTipo);
    });

    // Si llegó desde una tarjeta del explorador, su tipo ya viene elegido.
    if (S.tipo) {
      var pre = cont.querySelector('input[name="davie-tipo"][value="' + S.tipo + '"]');
      if (pre) pre.checked = true;
    }
  }

  function onTipo() {
    var elegido = marcado('davie-tipo');
    // Volver a tocar el mismo tipo no puede borrar lo que ya se eligió abajo.
    var cambio = elegido !== S.tipo;
    S.tipo = elegido;
    if (cambio) {
      S.tramo = null; S.modelo = null; S.modeloPrecio = null;
      setHidden('davie-budget', '');
      setHidden('davie-model-out', 'Aún no lo sé');
    }
    setHidden('davie-tipo-out', tipoTexto());
    limpiarError();

    var nota = form.querySelector('[data-note="otras-zonas"]');
    var next = $('davie-next');

    if (S.tipo === 'bajo') {
      var tpl = ($('davie-msg-otras') && $('davie-msg-otras').getAttribute('data-tpl')) || '';
      var txt = tpl
        .replace('{townhome}', piso('townhome') !== null ? money(piso('townhome')) : 'su precio de entrada')
        .replace('{single}', piso('single') !== null ? money(piso('single')) : 'su precio de entrada');
      if ($('davie-msg-otras')) $('davie-msg-otras').textContent = txt;
      show(nota, true);
      // El documento pide el botón explícito acá, así que no se avanza solo.
      if (next) { next.textContent = 'Quiero explorar opciones en otras zonas'; show(next, true); }
      return;
    }

    show(nota, false);
    if (next) show(next, false);
    avanzar();
  }

  /* ============================================================
     Pantalla 5 · presupuesto
     ============================================================ */
  function pintarPresupuesto() {
    var cont = $('davie-presu-opts'), titulo = $('davie-presu-titulo');
    if (!cont) return;
    var tramos, texto;

    if (S.tipo === 'bajo') {
      var pg = piso(null);
      tramos = pg !== null ? tramosPorDebajo(pg)
        : [{ from: 0, to: 300000 }, { from: 300000, to: 450000 }, { from: 450000, to: 600000 }];
      texto = '¿Qué presupuesto te gustaría mantener?';
    } else if (S.tipo === 'ambas') {
      tramos = tramosCombinados();
      texto = '¿Cuál es tu presupuesto aproximado?';
    } else {
      tramos = tramosDeCategoria(S.tipo);
      if (!tramos.length) tramos = tramosCombinados();
      texto = '¿Cuál es tu presupuesto para ' + (CAT_LABEL[S.tipo] || 'tu compra').toLowerCase() + '?';
    }
    if (!tramos.length) tramos = [{ from: 0, to: null }];
    if (titulo) titulo.textContent = texto;

    cont.innerHTML = tramos.map(function (t) {
      var lbl = etiquetaTramo(t);
      var ini = inicialTramo(t);
      return '<label class="davie-opt davie-opt--compact">' +
        '<input type="radio" name="davie-presu" value="' + lbl + '" data-from="' + t.from + '"' +
        ' data-to="' + (t.to === null ? '' : t.to) + '">' +
        '<span class="davie-opt__body"><b>' + lbl + '</b>' +
        (ini ? '<em>' + ini + '</em>' : '') + '</span></label>';
    }).join('');

    cont.querySelectorAll('input[name="davie-presu"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var to = r.getAttribute('data-to');
        var nuevo = {
          label: r.value,
          from: parseInt(r.getAttribute('data-from'), 10) || 0,
          to: to === '' ? null : parseInt(to, 10)
        };
        // Cambiar de tramo puede dejar afuera el modelo que se había elegido.
        if (!S.tramo || S.tramo.label !== nuevo.label) {
          S.modelo = null; S.modeloPrecio = null;
          setHidden('davie-model-out', 'Aún no lo sé');
        }
        S.tramo = nuevo;
        setHidden('davie-budget', r.value);
        limpiarError();
        avanzar();
      });
    });

    if (S.tramo) {
      var pre = cont.querySelector('input[name="davie-presu"][value="' + S.tramo.label + '"]');
      if (pre) pre.checked = true;
    }
  }

  /* ============================================================
     Pantalla 6 · modelo, ya filtrado por el presupuesto
     ============================================================ */
  function pintarModelos() {
    var cont = $('davie-modelo-opts'), titulo = $('davie-modelo-titulo');
    if (!cont) return;
    var items = modelosEnRango();
    if (titulo) {
      titulo.textContent = items.length === 1
        ? '¿Te interesa este modelo?'
        : 'De los que entran en tu presupuesto, ¿alguno te llama la atención?';
    }
    var html = items.map(function (m) {
      var etiqueta = m.available ? m.name : m.name + ' — sold out';
      return '<label class="davie-opt davie-opt--compact">' +
        '<input type="radio" name="davie-modelo" value="' + m.name + '" data-price="' + m.price + '">' +
        '<span class="davie-opt__body"><b>' + etiqueta + '</b>' +
        '<em>' + money(m.price) + ' · inicial 5% <strong>' + inicial(m.price) + '</strong></em></span></label>';
    });
    html.push('<label class="davie-opt davie-opt--compact">' +
      '<input type="radio" name="davie-modelo" value="" data-price="">' +
      '<span class="davie-opt__body"><b>Todavía no me decido</b></span></label>');
    cont.innerHTML = html.join('');

    cont.querySelectorAll('input[name="davie-modelo"]').forEach(function (r) {
      r.addEventListener('change', function () {
        S.modelo = r.value || null;
        var p = parseInt(r.getAttribute('data-price'), 10);
        S.modeloPrecio = isNaN(p) || p <= 0 ? null : p;
        setHidden('davie-model-out', S.modelo || 'Aún no lo sé');
        limpiarError();
        avanzar();
      });
    });

    // Si venía marcado de antes, o desde una tarjeta del explorador, se respeta.
    var quiere = S.modelo || pendienteModelo;
    if (quiere) {
      var pre = cont.querySelector('input[name="davie-modelo"][value="' + quiere + '"]');
      if (pre) {
        pre.checked = true;
        S.modelo = quiere;
        var pp = parseInt(pre.getAttribute('data-price'), 10);
        S.modeloPrecio = isNaN(pp) || pp <= 0 ? null : pp;
        setHidden('davie-model-out', S.modelo);
      }
      pendienteModelo = null;
    }
  }

  /* ============================================================
     Pantallas 7, 8 y 9
     ============================================================ */
  form.querySelectorAll('input[name="davie-plazo"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.plazo = r.value; setHidden('davie-time', r.value); limpiarError(); avanzar();
    });
  });
  form.querySelectorAll('input[name="davie-pago"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.pago = r.value; setHidden('davie-pay', r.value); limpiarError(); avanzar();
    });
  });
  form.querySelectorAll('input[name="davie-incentivos"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.incentivos = r.value; setHidden('davie-incent', r.value); limpiarError(); avanzar();
    });
  });

  /* ============================================================
     Validación
     ============================================================ */
  function validEmail() { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('davie-email')); }
  function validPhone() { return digits(val('davie-phone')).length >= 7; }

  function valida(n) {
    if (n === 1 && !S.situacion) return 'Elige la opción que describe tu situación.';
    if (n === 2 && !S.acuerdo) return 'Cuéntame si tienes un acuerdo firmado.';
    if (n === 3 && !S.licencia) return 'Indica dónde tienes tu licencia.';
    if (n === 4 && !S.tipo) return 'Elige qué te interesa explorar.';
    if (n === 5 && !S.tramo) return 'Elige un rango de presupuesto.';
    if (n === 7 && !S.plazo) return 'Cuéntame para cuándo estás considerando comprar.';
    if (n === 8 && !S.pago) return 'Elige cómo pensabas pagarla.';
    if (n === 9 && !S.incentivos) return 'Elige una de las tres opciones.';
    if (n === 10) {
      if (!val('davie-name')) return 'Necesito tu nombre para poder contactarte.';
      if (!validPhone()) return 'Revisa el teléfono: faltan dígitos.';
      if (!validEmail()) return 'Revisa el correo electrónico.';
    }
    return null;
  }

  /* ---- Navegación manual ---- */
  var btnNext = $('davie-next'), btnBack = $('davie-back');
  if (btnNext) btnNext.addEventListener('click', function () {
    var msg = valida(actual);
    if (msg) { error(msg); return; }
    ir(siguiente(actual));
  });
  if (btnBack) btnBack.addEventListener('click', function () { ir(anterior(actual)); });

  // Enter avanza en vez de enviar: el submit nativo dispararía el captcha de Shopify
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.tagName === 'TEXTAREA') return;
    e.preventDefault();
    if (esUltimo(actual)) enviar();
    else if (btnNext && !btnNext.hidden) btnNext.click();
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); });

  /* ============================================================
     Preselección desde las tarjetas del explorador
     ============================================================ */
  document.querySelectorAll('.davie-model-select').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var nombre = btn.getAttribute('data-model') || '';
      var entrada = CATALOGO.filter(function (m) { return m.name === nombre; })[0];
      if (entrada) {
        // Se recuerdan el modelo y su tipo. El filtro inicial igual se respeta:
        // saltearlo rompería la lógica que pidió Andrew.
        pendienteModelo = entrada.name;
        S.tipo = entrada.cat;
        setHidden('davie-tipo-out', tipoTexto());
        var pre = form.querySelector('input[name="davie-tipo"][value="' + entrada.cat + '"]');
        if (pre) pre.checked = true;
      }
      var destino = document.getElementById('davie-lead-form');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ============================================================
     Calificación y valor para Meta
     ============================================================ */
  function califica() {
    if (S.situacion !== 'comprador' && !(S.situacion === 'con-realtor' && S.acuerdo === 'no')) return false;
    if (S.tipo === 'bajo') return false; // se conserva el lead, pero no entrena a la campaña
    if (!validEmail() || !validPhone()) return false;
    // Los plazos pasaron de cinco a tres el 2026-09-15. Si esta linea no se
    // hubiera actualizado, NINGUN lead habria vuelto a contar como calificado
    // y la campana de Meta se habria quedado sin senal, sin avisar.
    return S.plazo === '1-2 meses' || S.plazo === '3-4 meses';
  }

  function leadValue() {
    if (S.modeloPrecio) return S.modeloPrecio;
    if (S.tramo) return S.tramo.from || 0;
    if (S.tipo === 'townhome' || S.tipo === 'single') {
      var pc = piso(S.tipo);
      if (pc !== null) return pc;
    }
    var precios = vendibles(null).map(function (m) { return m.price; });
    if (precios.length) return Math.round(precios.reduce(function (a, b) { return a + b; }, 0) / precios.length);
    return 800000;
  }

  /* ============================================================
     Armado del envío
     ============================================================ */
  function canal() {
    var el = form.querySelector('input[name="contact[Contacto preferido]"]:checked');
    return el ? el.value : 'WhatsApp';
  }
  function modeloTexto() { return S.modelo || 'Aún no lo sé'; }
  function situacionTexto() {
    if (S.situacion === 'comprador') return 'Comprador sin Realtor';
    if (S.situacion === 'con-realtor') return 'Trabaja con Realtor' + (S.acuerdo === 'no' ? ', sin acuerdo firmado' : '');
    // "REALTOR" en mayúsculas y al principio: es la marca con la que Andrew
    // arma la lista de exclusión de la pauta, así que tiene que ser filtrable.
    if (S.situacion === 'realtor') {
      if (S.licencia === 'fl') return 'REALTOR - Florida';
      if (S.licencia === 'fuera') return 'REALTOR - Fuera de Florida';
      return 'REALTOR';
    }
    return '';
  }
  function tipoTexto() {
    if (S.tipo === 'bajo') return 'Presupuesto más bajo (buscar fuera de Davie)';
    if (S.tipo === 'ambas') return 'Ambas opciones';
    return CAT_SINGULAR[S.tipo] || '';
  }

  function mensajeContacto() {
    var tpl = val('davie-wa-msg') ||
      'Hola Andrew, soy {nombre}. Me registré en la página de Davie Lake View y quisiera recibir precios y disponibilidad.';
    var nombre = val('davie-name');
    // El Realtor no viene a comprar: pegarle la lista de respuestas de comprador
    // no tendría sentido.
    if (S.situacion === 'realtor') {
      return 'Hola Andrew, soy ' + nombre + '. Soy Realtor' +
        (S.licencia === 'fuera' ? ' fuera de Florida' : ' con licencia en Florida') +
        ' y me registré en la página de Davie Lake View.';
    }
    return tpl.replace('{nombre}', nombre) +
      '\n\nEstas son mis respuestas:' +
      '\n• Busco: ' + tipoTexto() +
      '\n• Presupuesto: ' + (S.tramo ? S.tramo.label : '—') +
      '\n• Modelo de interés: ' + modeloTexto() +
      '\n• Cuándo pienso comprar: ' + (S.plazo || '—') +
      '\n• Forma de pago: ' + (S.pago || '—') +
      (S.incentivos ? '\n• Incentivos de constructora: ' + S.incentivos : '');
  }
  function whatsappUrl() {
    return 'https://wa.me/' + (digits(val('davie-wa')) || '17864428485') +
      '?text=' + encodeURIComponent(mensajeContacto());
  }
  function smsUrl() {
    return 'sms:+' + (digits(val('davie-wa')) || '17864428485') +
      '?&body=' + encodeURIComponent(mensajeContacto());
  }

  function buildPayload(qualified, eventId) {
    return {
      event_id: eventId,
      event_name: 'Lead',
      qualified: qualified,
      event_source_url: window.location.href,
      name: val('davie-name'),
      email: val('davie-email'),
      phone: fullPhone(),
      model: modeloTexto(),
      time: S.plazo || '',
      pay: S.pago || '',
      budget: S.tramo ? S.tramo.label : '',
      contact_pref: canal(),
      situacion: situacionTexto(),
      tipo: tipoTexto(),
      incentivos: S.incentivos || '',
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc'),
      custom: {
        content_name: 'Davie Lake View',
        content_category: 'Real Estate Lead',
        currency: 'USD',
        value: leadValue()
      }
    };
  }

  function buildBody() {
    return [
      'Nuevo lead — Landing Davie Lake View',
      'Situación: ' + situacionTexto(),
      'Nombre: ' + val('davie-name'),
      'Email: ' + val('davie-email'),
      'Teléfono: ' + fullPhone(),
      'Busca: ' + tipoTexto(),
      'Presupuesto: ' + (S.tramo ? S.tramo.label : '—'),
      'Modelo de interés: ' + modeloTexto(),
      'Compra estimada: ' + (S.plazo || '—'),
      'Forma de pago: ' + (S.pago || '—'),
      'Incentivos: ' + (S.incentivos || '—'),
      'Contacto preferido: ' + canal(),
      'Calificación: ' + (califica() ? 'CALIFICADO' : 'NO CALIFICADO')
    ].join('\n');
  }

  function sendLead(qualified, eventId) {
    if (TEST_MODE) return;
    var payload = buildPayload(qualified, eventId);
    if (qualified) {
      try {
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead', payload.custom, { eventID: eventId });
      } catch (err) {}
    }
    var capiUrl = val('davie-capi');
    if (capiUrl) {
      try {
        fetch(capiUrl, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      } catch (e) {}
    }
    // Envío aparte para guardar al lead como cliente de Shopify (email
    // marketing). Va a otro Worker a propósito: si falla, el aviso, la
    // planilla y Meta siguen saliendo por el de arriba.
    var leadsUrl = val('davie-leads');
    if (leadsUrl) {
      try {
        fetch(leadsUrl, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(buildShopifyLead(qualified))
        }).catch(function () {});
      } catch (e) {}
    }
  }

  function buildShopifyLead(qualified) {
    var tags = ['lead-davie', qualified ? 'calificado' : 'no-calificado'];
    if (S.situacion === 'realtor') tags.push('realtor');
    if (S.tipo === 'townhome' || S.tipo === 'ambas') tags.push('busca-townhome');
    if (S.tipo === 'single' || S.tipo === 'ambas') tags.push('busca-single-family');
    var m = (S.modelo || '').match(/Model\s+(\d-[A-Z]+)/i);
    if (m) tags.push('modelo-' + m[1].toLowerCase());
    var mk = $('davie-marketing');
    return {
      email: val('davie-email'),
      name: val('davie-name'),
      phone: fullPhone(),
      marketing_ok: !!(mk && mk.checked),
      source: 'Landing Davie Lake View',
      tags: tags,
      answers: {
        'Situación': situacionTexto(),
        'Busca': tipoTexto(),
        'Presupuesto': S.tramo ? S.tramo.label : '',
        'Modelo': modeloTexto(),
        'Compra': S.plazo || '',
        'Pago': S.pago || '',
        'Incentivos': S.incentivos || '',
        'Contacto preferido': S.situacion === 'realtor' ? '' : canal(),
        'Calificación': qualified ? 'CALIFICADO' : 'NO CALIFICADO',
        'Página': window.location.href.split('#')[0]
      }
    };
  }

  function ocultarFormulario() {
    for (var i = 1; i <= MAX; i++) show(pasoEl(i), false);
    show($('davie-nav'), false);
    show($('davie-prog'), false);
    show($('davie-form-note'), false);
  }
  function mostrarExito(id) {
    ocultarFormulario();
    var blocks = form.querySelectorAll('.davie-form-success');
    for (var j = 0; j < blocks.length; j++) {
      var esEste = blocks[j].id === id;
      blocks[j].style.display = esEste ? '' : 'none';
      blocks[j].classList.toggle('is-visible', esEste);
    }
  }
  function textoExito(t, x) {
    var s = $('davie-success');
    if (!s) return;
    var h = s.querySelector('h3'), p = s.querySelector('p');
    if (h && t) h.textContent = t;
    if (p && x) p.textContent = x;
  }

  /* ---- Panel de prueba ---- */
  function panelPrueba(qualified, eventId) {
    var panel = $('davie-testpanel');
    if (!panel) return;
    var payload = buildPayload(qualified, eventId);
    var m = canal();
    var url = m === 'Llamada' ? '' : (m === 'SMS' ? smsUrl() : whatsappUrl());

    var filas = [
      ['Calificación', qualified ? '<b>CALIFICADO</b> — habría ido a Meta' : 'NO CALIFICADO — no habría ido a Meta'],
      ['Pixel de Meta', qualified ? 'bloqueado (habría disparado Lead)' : 'no correspondía'],
      ['Worker (email + planilla)', 'bloqueado'],
      ['Lead a Shopify', 'bloqueado'],
      ['Canal elegido', m],
      ['Redirección', url ? 'bloqueada' : 'no corresponde (muestra el número)'],
      ['Valor para Meta', 'USD ' + payload.custom.value.toLocaleString('en-US')]
    ];
    var grid = $('davie-testpanel-grid');
    if (grid) grid.innerHTML = filas.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('');
    var pre = $('davie-testpanel-json');
    if (pre) pre.textContent = JSON.stringify(payload, null, 2);

    var abrir = $('davie-test-open');
    if (abrir) { abrir.hidden = !url; abrir.onclick = function () { if (url) window.open(url, '_blank'); }; }

    var otra = $('davie-test-again');
    if (otra) otra.onclick = function () {
      enviado = false;
      panel.hidden = true;
      show($('davie-nav'), true);
      show($('davie-prog'), true);
      show($('davie-form-note'), true);
      form.querySelectorAll('.davie-form-success').forEach(function (b) {
        b.style.display = 'none'; b.classList.remove('is-visible');
      });
      ir(1);
    };
    panel.hidden = false;
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ---- Envío ---- */
  function enviar() {
    if (enviado) return;
    var msg = valida(10);
    if (msg) { error(msg); return; }
    enviado = true;

    setHidden('davie-phone-full', fullPhone());
    setHidden('davie-wa-link', 'https://wa.me/' + digits(phoneE164()));
    setHidden('davie-situacion-out', situacionTexto());
    setHidden('davie-tipo-out', tipoTexto());

    var qualified = califica();
    setHidden('davie-body', buildBody());
    setHidden('davie-quality', qualified ? 'CALIFICADO' : 'NO CALIFICADO');

    var eventId = uuid();

    if (TEST_MODE) {
      ocultarFormulario();
      panelPrueba(qualified, eventId);
      return;
    }

    sendLead(qualified, eventId);

    var action = form.getAttribute('action') || '/contact';
    try {
      fetch(action, {
        method: 'POST', body: new FormData(form), keepalive: true,
        headers: { 'Accept': 'application/json' }
      }).catch(function () {});
    } catch (err) {}

    // El Realtor cierra en su propia pantalla, sin redirect. Sus datos ya
    // viajaron en el POST de arriba: abrir el chat era el unico motivo del
    // salto, y Andrew prefiere contactarlo el. Pedido del 2026-09-15.
    if (S.situacion === 'realtor') {
      mostrarExito('davie-success-realtor');
      return;
    }

    var m = canal();
    if (m === 'Llamada') {
      mostrarExito('davie-success-call');
    } else {
      textoExito(val('davie-redirect-title'), val('davie-redirect-text'));
      mostrarExito('davie-success');
      var url = m === 'SMS' ? smsUrl() : whatsappUrl();
      setTimeout(function () { window.location.href = url; }, 700);
    }
  }
  var btnSend = $('davie-submit-btn');
  if (btnSend) btnSend.addEventListener('click', enviar);

  /* ---- Botón de copiar el número (opción Llamada) ---- */
  (function initCall() {
    function copiar(text, done) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () {});
        return;
      }
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
    var b = $('davie-call-copybtn');
    if (b) {
      var orig = b.textContent;
      b.addEventListener('click', function () {
        copiar(b.getAttribute('data-num') || '', function () {
          b.textContent = '¡Número copiado!';
          setTimeout(function () { b.textContent = orig; }, 1800);
        });
      });
    }
    var n = $('davie-call-num');
    if (n) {
      var fb = n.querySelector('.davie-call__copy');
      n.addEventListener('click', function () {
        copiar(n.getAttribute('data-num') || '', function () {
          if (fb) { fb.textContent = '¡Copiado!'; setTimeout(function () { fb.textContent = ''; }, 1800); }
        });
      });
    }
  })();

  /* ---- Arranque ---- */
  pintarTipos();
  ir(1);

  // El editor de temas vuelve a dibujar la sección de modelos cuando Andrew
  // cambia un precio: hay que releer el catálogo o el formulario queda viejo.
  document.addEventListener('shopify:section:load', function () {
    CATALOGO = readCatalog();
    pintarTipos();
    if (actual === 4) pintarPisos();
    if (actual === 5) pintarPresupuesto();
    if (actual === 6) pintarModelos();
  });
})();
